'use strict';

/* ThreeThing Events: toggling main thumbNail and pinning LeftRail onScroll*/

angular.module('storyApp').factory('threeThingEvents', ['storyProperties', 'storyScroll', function(storyProperties, storyScroll) {
    var threeThingsE = {
        // set the gap between the top of the document and the first article content, using it as the top pin point

        getTopPinPosition: function() {
            //console.log(storyProperties);
            var position = 0;
            var promoH = 0;
            if (storyProperties.bodyClassList.contains('banner-ad-pin')) {
                position = storyProperties.secNavHeight; //storyProperties.mainStory.offsetTop - storyProperties.belowNavAd.offsetHeight - storyProperties.navHeight;
            } else {
                position = storyProperties.secNavHeight + storyProperties.bannerAdContainer.offsetHeight + storyProperties.getPromoHeight();
            }
            return position;
        },

        //pin the 3 things left rail when users scroll down and reach top of the main story when banner Ad is out of view)
        //pin the 3 things left rail when users scroll up and pass top of the main story when banner Ad is in view)
        toggleLeftRailPin: function(scrollYPos) {
            var that = this,
                top = (that.getTopPinPosition()),
                sideBar = storyProperties.sideBar,
                hasFixClass = sideBar.classList.contains('fix');

            if (!hasFixClass && scrollYPos >= top) {

                sideBar.classList.add('fix');
                //sideBar.style.transition = 'none';

            } else if (hasFixClass && scrollYPos <= top) {
                //sideBar.style.transition = null;
                sideBar.classList.remove('fix');
            }

            return that;
        },

        //calling toggleLeftRailPin and toggleMainThumbNail
        onEvent: function(viewPort, scrollYPos) {
            //only run following threeThingEvents (pinning 3 things left rail and toggling main story thumbnail on viewport 768 and above
            if (viewPort !== 'mobile') {
                var that = threeThingsE;

                that.toggleLeftRailPin(scrollYPos);
            }
        },


        init: function() {
            var that = this;

            //add to the callback queue that will be hooked in storyScroll onScroll event
            storyScroll.addToQueue(that.onEvent);
        }

    };

    //run this on page load
    threeThingsE.init();


    return threeThingsE;

}]);


// WEBPACK FOOTER //
// ./assets/components/threethings/factories/threeThingEvents.js